import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class VideoService {
    async fetch(page, pageSize, search) {
        const pageParam = `page=${page}&perPage=${pageSize}`
        let params = search ? `search=${search}` : pageParam;
        const response = await ajaxService.get(`/videos?${params}`);
        if (response ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }
    async add(data) {
        const response = await ajaxService.post(`/videos`, data);
        if (response.success ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }
    async update(id, data) {
        const response = await ajaxService.post(`/videos/`, data, id);
        if (response?.success ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }

    async delete(id) {
        const response = await ajaxService.delete(`/videos/`, id);
        if (response ?? false) {
            return response;
        }
    }
}

const videoService = new VideoService();
export default videoService;
